import React from 'react';
import { Scroll, Heart, Eye, Leaf } from 'lucide-react';
import { teachings } from '../data/mockData';
import { useLanguage } from '../context/LanguageContext';

const iconMap = {
  1: Scroll,
  2: Heart,
  3: Eye,
  4: Leaf
};

const TeachingsSection = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-16" style={{
      background: 'linear-gradient(180deg, #160c30 0%, #130a28 100%)'
    }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
            {t('teachingsTitle')}
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            {t('teachingsDesc')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {teachings.map((teaching) => {
            const Icon = iconMap[teaching.id] || Scroll;
            return (
              <div 
                key={teaching.id} 
                className="bg-[#1a1a2e]/50 rounded-xl p-6 text-center transition-all duration-300 hover:bg-[#2a2a3e]/50 hover:transform hover:-translate-y-1"
              >
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-pink-600/30 to-purple-600/30 flex items-center justify-center mx-auto mb-4">
                  <Icon className="w-7 h-7 text-pink-400" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">{teaching.title}</h3>
                <p className="text-gray-400 text-sm">{teaching.description}</p>
              </div>
            );
          })}
        </div>

        {/* Philosophy Statement */}
        <div className="bg-[#1a1a2e]/50 rounded-2xl p-8 lg:p-12 border border-purple-500/10">
          <h3 className="text-2xl font-bold text-white mb-6 text-center">{t('ourPhilosophy')}</h3>
          <div className="space-y-4 text-gray-300 leading-relaxed text-center max-w-4xl mx-auto">
            <p>{t('philosophyText1')}</p>
            <p>{t('philosophyText2')}</p>
            <p>{t('philosophyText3')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeachingsSection;
